export const ChevronIcon = ({ direction = 'down' }) => {
    let rotation = '0';
    switch (direction) {
        case 'up':
            rotation = '180';
            break;
        case 'right':
            rotation = '270';
            break;
        case 'left':
            rotation = '90';
            break;
        case 'down':
        default:
            rotation = '0';
            break;
    }

    return (
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" 
            style={{transform: `rotate(${rotation}deg)`}}>
            <path d="m3.2927 8.2931c0.39043-0.39062 1.0236-0.39077 1.4142-3.3e-4l7.2926 7.2892 7.2926-7.2892c0.3906-0.39044 1.0238-0.39029 1.4142 3.3e-4 0.3905 0.39062 0.3903 1.0238-3e-4 1.4142l-7.9995 7.9957c-0.3905 0.3903-1.0234 0.3903-1.4139 0l-7.9995-7.9957c-0.39062-0.39043-0.39077-1.0236-3.3e-4 -1.4142z" />
        </svg>
    );
};
